"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.discreteValidationSchema = void 0;
const yup_1 = require("yup");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const types_1 = require("@framework/types");
exports.discreteValidationSchema = (0, yup_1.object)().shape({
    contractId: yup_rules_1.dbIdValidationSchema,
    attribute: (0, yup_1.string)()
        .required("form.validations.valueMissing")
        .matches(/^[A-Z][A-Z0-9]*$/, "form.validations.patternMismatch")
        .max(32, "form.validations.rangeOverflow"),
    discreteStatus: (0, yup_1.mixed)()
        .oneOf(Object.values(types_1.DiscreteStatus))
        .required("form.validations.valueMissing"),
    discreteStrategy: (0, yup_1.mixed)()
        .oneOf(Object.values(types_1.DiscreteStrategy))
        .required("form.validations.valueMissing"),
    growthRate: (0, yup_1.number)().when("discreteStrategy", {
        is: (discreteStrategy) => discreteStrategy === types_1.DiscreteStrategy.EXPONENTIAL,
        then: () => (0, yup_1.number)()
            .required("form.validations.valueMissing")
            .integer("form.validations.badInput")
            .min(1, "form.validations.rangeUnderflow"),
    }),
    price: mui_inputs_asset_1.templateAssetValidationSchema,
});
//# sourceMappingURL=validation.js.map